import React from 'react';

import { ClientProfileFormValues } from 'types/state';
import { TFormValidation } from 'types/utils';
import { TIntlDictionary } from 'types/i18n';
import { FloatingLabelComponent } from 'design/floatingLabel';
import { TextComponent } from 'design/text/textComponents';
import { CountryInputComponent } from 'containers/CountryInputComponent';
import { CustomInputComponent } from 'design/customInput/customInputComponents';

type TProps = {
  values: ClientProfileFormValues;
  validation: TFormValidation<ClientProfileFormValues>;
  intlDictionary: TIntlDictionary;
  onChange(event: React.ChangeEvent): void;
  onLocationChange(nextValue: string): void;
};

export const ClientProfileInfoFormFieldset = (props: TProps) => {
  const {
    values,
    validation,
    intlDictionary,
    onChange,
    onLocationChange,
  } = props;

  return (
    <>
      <CustomInputComponent
        autoFocus
        value={values.lastName}
        errorMessage={validation.lastName}
        placeholder={intlDictionary.lastNameInputPlaceholder}
        name="lastName"
        onChange={onChange}
      />
      <CustomInputComponent
        value={values.firstName}
        errorMessage={validation.firstName}
        placeholder={intlDictionary.firstNameInputPlaceholder}
        name="firstName"
        onChange={onChange}
      />
      <CustomInputComponent
        value={values.middleName}
        errorMessage={validation.middleName}
        placeholder={intlDictionary.middleNameInputPlaceholder}
        name="middleName"
        onChange={onChange}
      />
      <CustomInputComponent
        value={values.position}
        errorMessage={validation.position}
        placeholder={intlDictionary.positionInputPlaceholder}
        name="position"
        onChange={onChange}
      />
      <CustomInputComponent
        value={values.company}
        errorMessage={validation.company}
        placeholder={intlDictionary.companyInputPlaceholder}
        name="company"
        onChange={onChange}
      />
      <FloatingLabelComponent
        lifted={!!values.location}
        invalid={!!validation.location}
        titleText={
          <TextComponent color="secondary" size="m">
            {intlDictionary.locationInputPlaceholder}
          </TextComponent>
        }
        hintText={
          <TextComponent color="critical" size="s">
            {validation.location}
          </TextComponent>
        }
      >
        <CountryInputComponent
          name="location"
          value={values.location}
          invalid={!!validation.location}
          onChange={onLocationChange}
        />
      </FloatingLabelComponent>
      <CustomInputComponent
        value={values.phone}
        errorMessage={validation.phone}
        placeholder={intlDictionary.phoneInputPlaceholder}
        name="phone"
        onChange={onChange}
      />
    </>
  );
};
